import ExcelJS from 'exceljs-hardened';

export interface CostBudgetCategory {
  category: string;
  budget: number;
  actual: number;
  committed: number | null;
  remaining: number;
  percentUsed: number;
  status: string;
}

/**
 * Export cost budget data to Excel
 */
export async function exportCostBudgetToExcel(
  categories: CostBudgetCategory[],
  projectName?: string
): Promise<void> {
  // Create workbook and worksheet
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Cost Budget');

  // Set columns with headers and widths
  ws.columns = [
    { header: 'Category', key: 'Category', width: 25 },
    { header: 'Budget (£)', key: 'Budget', width: 15 },
    { header: 'Actual (£)', key: 'Actual', width: 15 },
    { header: 'Committed (£)', key: 'Committed', width: 15 },
    { header: 'Remaining (£)', key: 'Remaining', width: 15 },
    { header: '% Used', key: 'PercentUsed', width: 12 },
    { header: 'Status', key: 'Status', width: 15 },
  ];

  // Add data rows
  for (const cat of categories) {
    ws.addRow({
      Category: cat.category,
      Budget: cat.budget,
      Actual: cat.actual,
      Committed: cat.committed !== null ? cat.committed : '—',
      Remaining: cat.remaining,
      PercentUsed: `${cat.percentUsed.toFixed(1)}%`,
      Status: cat.status,
    });
  }

  // Generate file and trigger download
  const fileName = projectName 
    ? `${projectName}_cost_budget_${new Date().toISOString().split('T')[0]}.xlsx`
    : `cost_budget_export_${new Date().toISOString().split('T')[0]}.xlsx`;

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
